import { useMemo } from 'react';

import { filterOutParcelOnlyRateErrors } from '../../../errors/parcel-rate-errors/is-parcel-only-rate-error';
import type { RateErrorEntry } from '../../../errors/parcel-rate-errors/is-parcel-only-rate-error';
import { emptyArrayOf } from 'ui-components/default-props/empty';
import { useFreightConfiguration } from './use-freight-configuration';

export const useVisibleRateErrors = (
  fulfillmentPlanId: string | undefined,
  errorOrErrors: RateErrorEntry | RateErrorEntry[] | null | undefined,
): RateErrorEntry[] => {
  const { isFreightLtl } = useFreightConfiguration(fulfillmentPlanId);

  return useMemo(() => {
    let errors: RateErrorEntry[];
    if (Array.isArray(errorOrErrors)) {
      errors = errorOrErrors;
    } else if (errorOrErrors) {
      errors = [errorOrErrors];
    } else {
      errors = emptyArrayOf<RateErrorEntry>();
    }
    return isFreightLtl ? filterOutParcelOnlyRateErrors(errors) : errors;
  }, [isFreightLtl, errorOrErrors]);
};
